import axios from 'axios';

const getShopDetails = (id) => {
  return axios
    .get(`${process.env.REACT_APP_API_URL}/api/dealer/${id}`)
    .then(res => res)
    .catch(err => err);
};

export default getShopDetails;
